import cls from 'classnames';
import { JsonLd } from 'react-schemaorg';
import { SoftwareApplication } from 'schema-dts';

import StarWithPartialFill from '../StarWithPartialFill';

import useStyles from './styles';
import { IToolRating } from './types';

const MAX_STARS_NUMBER = 5;

function ToolRating({ review, reviewsNumber, title = 'Tool Rating', className }: IToolRating) {
  const noOfFullStart = Math.floor(review);
  const partialStarPercentage = (review - noOfFullStart) * 100;
  const noOfEmptyStars = MAX_STARS_NUMBER - Math.ceil(review);

  const classes = useStyles();
  return (
    <>
      <div className={cls(classes.root, className)}>
        <span className={classes.title}>{title}</span>
        <div className={classes.starsContainer}>
          <div className={classes.starts}>
            {[...Array(noOfFullStart).fill(0)].map((_, index) => {
              return <StarWithPartialFill key={index} fillPercentage={100} index={index} />;
            })}
            <StarWithPartialFill fillPercentage={partialStarPercentage} index={-1} />
            {noOfEmptyStars != 0 &&
              [...Array(noOfEmptyStars).fill(0)].map((_, index) => {
                return <StarWithPartialFill key={index} fillPercentage={0} index={index + 20} />;
              })}
          </div>
          <span className={classes.review}>{review}</span>
        </div>
        <span className={classes.noOfReviews}>({reviewsNumber.toLocaleString('en-US')})</span>
      </div>
      <JsonLd<SoftwareApplication>
        item={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Quicktools by Picsart',
          operatingSystem: 'Mac, Windows, IOS,  Android',
          applicationCategory: 'BrowserApplication',
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingCount: reviewsNumber,
            ratingValue: review,
          },
        }}
      />
    </>
  );
}
export default ToolRating;
